// Check all / Uncheck all (#9764): the pair of links above every list of
// checkboxes, so a long list is ticked or cleared in one click. The caller
// decides what "all" means (a locked or inherited row may be left out) and
// does the ticking; this only draws the two buttons and disables the one that
// would change nothing.
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CheckAllBarProps {
  /** How many of the list's items are ticked now. */
  checked: number;
  /** How many items "Check all" would tick. */
  total: number;
  /** true for Check all, false for Uncheck all. */
  onChange: (checked: boolean) => void;
  /** Locks both, for a list that is read-only right now. */
  disabled?: boolean;
  className?: string;
}

// The design system's link button, shrunk to sit as a caption above a list.
const LINK = "h-auto px-1 py-0 text-xs";

const CheckAllBar = ({ checked, total, onChange, disabled, className }: CheckAllBarProps) => (
  <div className={cn("flex items-center gap-2", className)}>
    <Button
      type="button"
      variant="link"
      className={LINK}
      disabled={disabled || total === 0 || checked >= total}
      onClick={() => onChange(true)}
    >
      Check all
    </Button>
    <span aria-hidden className="h-3 w-px bg-border" />
    <Button
      type="button"
      variant="link"
      className={LINK}
      disabled={disabled || checked === 0}
      onClick={() => onChange(false)}
    >
      Uncheck all
    </Button>
  </div>
);

export default CheckAllBar;
